// ---------------------------------------------------------------------------
// Audit module — i18n messages (de-AT)
// ---------------------------------------------------------------------------

export const auditLocales = {
  'de-AT': {
    admin: {
      audit: {
        title: 'Audit-Log',
        subtitle: 'Nachvollziehbarkeit sensibler Aktionen im System.',
        empty: 'Keine Log-Einträge gefunden.',
        export_csv: 'CSV exportieren',
        sensitive_badge: 'Sensitiv',
        filters: {
          search: 'Suche',
          search_placeholder: 'Beschreibung, Pfad, Email …',
          user_id: 'Benutzer-ID',
          entity_type: 'Entitäts-Typ',
          action: 'Aktion',
          from_date: 'Von',
          to_date: 'Bis',
          all: 'Alle',
        },
        columns: {
          timestamp: 'Zeitstempel',
          user: 'Benutzer',
          action: 'Aktion',
          entity: 'Entität',
          path: 'Pfad',
          status: 'Status',
          ip: 'IP',
          sensitive: 'Sensitiv',
          actions: 'Aktionen',
        },
        actions: {
          open_detail: 'Details öffnen',
        },
        detail: {
          title: 'Log-Eintrag Details',
          close: 'Schließen',
          metadata: 'Metadaten',
          before: 'Vorher',
          after: 'Nachher',
          no_snapshot: 'Kein Snapshot vorhanden.',
        },
      },
    },
  },
} as const;
